export default function getResource(label, vars = []) {
    const resources = {
        emailAndMailPreferences: 'Courriel et préférences',
        communicationPreferences: 'Préférences en matière de communication'
    };
    return resources[label];
}
